const apiConfig = {
  // Production Api Url
  apiBaseURL: "https://prodapi.ebillingamerica.com",
  baseURL: "https://ebillingamerica.com",
  // Bridgepay Secure payment api Tokenpay dev and uat
  apiTokenpay: "https://www.bridgepaynetsecuretx.com/Bridgepay.WebSecurity/TokenPay/js/tokenPay.js",
  REACT_APP_ENCRYPTION_KEY: "f1e2d3c4b5a69788c7d6e5f4a3b2c1d0",
  hcaptchaSiteKey:"88ccae00-7df8-44ba-82bc-d50ea76233de"

};

export default apiConfig;
